import Vue from 'vue';
import VueRouter from 'vue-router';
import {isAuthenticated} from '@/api/auth';
import {setUser} from '@/store/user';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/HomePage')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '@/views/about/AboutPage')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/SupportPage')
  },
  {
    path: '/voting-trends/:nodeId',
    name: 'VotingTrends',
    props: true,
    component: () => import(/* webpackChunkName: "votes" */ '@/views/votingTrends/VotingTrends')
  },
  {
    path: '/voting-trends/:nodeId/widget',
    name: 'VotingTrendsWidget',
    props: true,
    component: () => import(/* webpackChunkName: "votesWidget" */ '@/views/votingTrends/VotingTrendsWidget')
  }
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.VUE_APP_BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  try {
    const auth = await isAuthenticated();
    if (auth && auth.user) {
      setUser(auth.user);
    }
  }
  catch (e) {
    console.error(e);
  }
  next();
});

export default router;
